var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_38_100",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 38 \\u2013 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2446",
    "data-name": "\\uC0AC\\uAC01\\uD615 2446",
    width: 15.67,
    height: 15.905,
    fill: "none",
    stroke: "#b9bebe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2447",
    "data-name": "\\uC0AC\\uAC01\\uD615 2447",
    width: 19.67,
    height: 19.905,
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4010",
    "data-name": "\\uADF8\\uB8F9 4010",
    transform: "translate(2.165 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4007",
    "data-name": "\\uADF8\\uB8F9 4007",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4006",
    "data-name": "\\uADF8\\uB8F9 4006",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_250",
    "data-name": "\\uC120 250",
    x2: 11.009,
    transform: "translate(4.335 6.235)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2988",
    "data-name": "\\uD328\\uC2A4 2988",
    d: "M0,0H7.377",
    transform: "translate(6.57 12.924)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4009",
    "data-name": "\\uADF8\\uB8F9 4009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4008",
    "data-name": "\\uADF8\\uB8F9 4008",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_252",
    "data-name": "\\uC120 252",
    y2: 3.505,
    transform: "translate(6.826 1.755)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_253",
    "data-name": "\\uC120 253",
    y2: 3.505,
    transform: "translate(13.977 1.755)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2937",
    "data-name": "\\uD328\\uC2A4 2937",
    d: "M.75,8.251V19.643H16.909V5.253H3.481Z",
    transform: "translate(1.005 -1.494)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2448",
    "data-name": "\\uC0AC\\uAC01\\uD615 2448",
    width: 24,
    height: 24,
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDate);
export default __webpack_public_path__ + "static/media/icoDate.ffd429b5c68e592313275b3859514951.svg";
export { ForwardRef as ReactComponent };